<template>
  <div tabindex="0" @keydown.space.enter="$emit('click')" class="closebtn" role="button" aria-label="close" :class="{'closebtn_alt':alt}">
    <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.96875 9.46387L24.0016 24.4967" stroke="#5B5D6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.96875 24.5361L24.0016 9.50328" stroke="#5B5D6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    alt: {type: Boolean, default: true}
  }
}
</script>

<style lang="sass">
.closebtn
  position: relative
  width: 24px
  cursor: pointer
  &_alt
    width: 32px
  &::before
    content: ''
    top: -15px
    right: -15px
    bottom: -15px
    left: -15px
  svg
    display: block
    stroke: colors.$bluefont
</style>